import FilterClients from './FilterClients';
import React, { Fragment, useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import i18n from '../../../../../i18n';

const Sidebar = () => {
    const [IsOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(true);

    const handleResize = () => {
        if (window.innerWidth <= 1199) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
    });

    const OnHandelClick = () => {
        setIsOpen(!IsOpen);
    };
    return (
        <Fragment>
            <Col xl="3" className="box-col-4 xl-40">
                <div className="job-sidebar">
                    {isMobile && <a className="btn btn-primary job-toggle" href="#javascript" onClick={OnHandelClick}>{i18n.t('Dashboard_ContractsReport_JobFilter')}</a>}
                    <div className={`job-left-aside custom-scrollbar ${IsOpen ? 'open' : ''}`}>
                        <div className="default-according style-1 faq-accordion job-accordion" id="accordionoc">
                            <Row>
                                <FilterClients />
   
                            </Row>
                        </div>
                    </div>
                </div>
            </Col>
        </Fragment>
    );
};

export default Sidebar;
